import React from "react";
import { useNavigate } from "react-router-dom";
import { formatDate, formatDateTime } from "../../utils/commonHelper";

const Listing = ({ payments = [] }) => {
  const navigate = useNavigate();
  const width = window.screen.width;
  return (
    <>
      <h2 className="text-24pt mb-4">Payments</h2>
      <div className="overflow-x-auto" style={{ maxWidth: `${width - 60}px` }}>
        <table className="w-full table-auto border-collapse bg-white rounded-[15px] ">
          <thead>
            <tr className=" text-left ">
              <th className="p-3 border-b font-sans font-normal border-b-gray">
               
              </th>
              <th className="p-3 border-b font-sans font-normal border-b-gray">
                Order / Meal
              </th>
            
              <th className="p-3 border-b font-sans font-normal border-b-gray">
                Amount Paid
              </th>
                <th className="p-3 border-b font-sans font-normal border-b-gray">
                Date & Time
              </th>
              <th className="p-3 border-b font-sans font-normal border-b-gray">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {payments.length === 0 ? (
              <tr>
                <td colSpan="6" className="p-3 text-center">
                  No payments found.
                </td>
              </tr>
            ) : (
              payments.map((payment, index) => (
                <tr
                  key={payment._id}
                  title="Click to view payment details"
                  className="hover:bg-[#eee] hover:shadow-md cursor-pointer"
                  onClick={() => navigate(`/account/payments/${payment._id}`)}
                >
                  <td className="p-3 border-b border-b-gray font-mono">
                    {index+1}
                  </td>
                  <td className="p-3 border-b border-b-gray text-base">
                    {payment.purpose}
                  </td>
                 
                  <td className="p-3 border-b border-b-gray text-orange">
                    {payment.totalAmount} AED
                  </td>
                   <td className="p-3 border-b border-b-gray font-mono text-sm">
                    {formatDate(payment.updatedAt)}
                  </td>
                  <td
                    className={`p-3 border-b border-b-gray  ${
                      payment.status === "1"
                        ? "text-quaternary"
                        : payment.status === "2"
                        ? "text-red-700"
                        : "text-orange"
                    }`}
                  >
                    {payment.status === "1"
                      ? "Paid"
                      : payment.status === "2"
                      ? "Cancelled"
                      : "Pending"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Listing;
